import { render, staticRenderFns } from "./oneColumnBlock.vue?vue&type=template&id=fd89379e&scoped=true&"
import script from "./oneColumnBlock.vue?vue&type=script&lang=js&"
export * from "./oneColumnBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd89379e",
  null
  
)

export default component.exports